/**
 * Disable Compliance Type Use Case
 */

import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class DisableTypeUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(id: number): Promise<void> {
    return await this.repository.disableType(id);
  }
}

